export const NAME = 'dashboardFilters';

export const SET_DASHBOARD_FILTERS = 'SET_DASHBOARD_FILTERS';
export const SAVE_DASHBOARD_FILTER = 'SAVE_DASHBOARD_FILTER';
export const DELETE_DASHBOARD_FILTER = 'DELETE_DASHBOARD_FILTER';
export const LOAD_DASHBOARD_FILTERS = 'LOAD_DASHBOARD_FILTERS';
export const UPDATE_FILTER = 'UPDATE_FILTER';
